import React, { useState, useEffect, useContext } from "react";
import Tab from "../tab/tab";
import TopBar from "../../scenes/global/Top-Bar";
import SideBar from "../../scenes/global/Side-Bar";
import BasicSelect from "../select/select";
import { TextArea } from "../textarea/textarea";
import Radio from "../radio/radio";
import { useSelector, useDispatch } from "react-redux";
import $ from "jquery";
import { LanguageContext } from "../../scenes/global/languageContext";
import {
  generate_professional_summary,
  dispatchJobtitle,
  clearPS,
  uppdateYOF,
  uppdateJobTitle,
  uppdateAbout,
  uppdateInterest,
  saveJobAndSum,
} from "../../Redux/ActionCreator";
import { createPortal } from "react-dom";
import LoaderModal from "../../components/LoaderModal";
import { useParams } from "react-router-dom";
import { Cv_id, generate_my_cv } from "../../Redux/ActionCreator";
import PaymentMethodModal from "../../components/PaymentMethodModal";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

export default function UserJobType(props) {
  const { language, handleLanguageChange } = useContext(LanguageContext);

  const params = useParams();
  const dispatch = useDispatch();
  const secret = useSelector(prev => prev.secret);
  const loading_stat = useSelector((load) => load.generateCV);
  const existing_cv_data = useSelector((prev) => prev.existingCV);
  const message = existing_cv_data.message;
  const activity = useSelector((act) => act.activities);
  const skills = useSelector((skills) => skills.skills);
  const title = useSelector((title) => title.jobTitle);
  const t_lang = useSelector((lg) => lg.t_lang);
  const personal_info = useSelector((info) => info.personal_info);
  const education = useSelector((edu) => edu.education);
  const p_skills = useSelector((skills) => skills.p_skills);
  const voluteer = useSelector((vol) => vol.voluntary);
  const award = useSelector((award) => award.award);
  const reference = useSelector((ref) => ref.reference);
  const lang = useSelector((lang) => lang.language);
  const cert = useSelector((cert) => cert.cert);
  const res_lang = useSelector((lang) => lang.lang);
  const profile = useSelector((e) => e.profile);
  const generated = useSelector(e => e.generateCV);
  const cv = useSelector(prev => prev.cvId);
  const userInfo = useSelector(e => e.userInfo);
  const profile1 = useSelector(e => e.login);
  let stat = profile1.profile_status.profile_status

  const [PsStat, setPsStat] = useState(false);
  const [loading, setLoading] = useState(false);
  // professional summary
  const summary = useSelector((summary) => summary.summary);
  console.log("summary", summary);
  const p_summary = summary.summary;
  const T_lang = t_lang.selected;
  const [hideModal, setHideModal] = useState(false);
  const [summaryBtnText, setSummaryBtnText] = useState("");
  const [path, setPath] = useState(false);
  const showModal = () => {
    setHideModal(false);
  };
  const navigate = useNavigate();

  React.useEffect(() => {
    console.log("location", window.location.pathname);
    if (
      window.location.pathname === "/user/profile/update/about" &&
      profile.message !== null
    ) {
      setPath(true);
      $('[name="goal"]').val(profile.message.About);
      $('[name="interest"]').val(profile.message.Interest);
      $('[name="YOF"]').val(profile.message.year_of_experience)
      $('[name="cvtype"]').val(profile.message.CvType)
      setSummaryBtnText("Update about");
    } else if (window.location.pathname === `/form/${cv.id}/update`) {
      $('[name="goal"]').val(generated.message.About);
      $('[name="interest"]').val(generated.message.Interest);
      $('[name="YOF"]').val(generated.message.year_of_experience)
      $('[name="cvtype"]').val(generated.message.CvType);
      setSummaryBtnText("Generate summary")
    } else {
      if (loading_stat.message !== null) {
        $('[name="interest"]').val(loading_stat.message.Interest);
        $('[name="YOF"]').val(loading_stat.message.year_of_experience)
        $('[name="cvtype"]').val(loading_stat.message.CvType)
      }
      setSummaryBtnText("Generate summary")
    }

    if (title.jobtitle !== null) {
      $('[name="cvtype"]').val(title.jobtitle);
    }

    if (message !== null) {
    }

    const filValue = (p_summary) => {
      if (message !== undefined && message !== null) {
        if (summary.summary !== null) {
          $('[name="goal"]').val(p_summary);
        } else {
          $('[name="goal"]').val(message.Professional_summary);
        }
      } else {
        if (summary.summary !== null) {
          $('[name="goal"]').val(p_summary);
        } else {
          $('[name="goal"]').val();
        }
      }
    };

    if (p_summary !== null) {
      filValue(p_summary);
    }
  }, [T_lang, p_summary]);

  console.log("Technical skill", skills.skills);

  const updateYOF = () => {
    // dispatch YOF
    dispatch(uppdateYOF($('[name="YOF"]').val()));
    $('[name="YOF"]').val("")
    {setTimeout(() => {
      toast.success("Year of experience updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
      });
  }, 50)}
  }

  const updateInterest = () => {
    dispatch(uppdateInterest($('[name="interest"]').val()));
    $('[name="interest"]').val("");
    {setTimeout(() => {
      toast.success("Interest updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
      });
  }, 50)}
  }

  const updateJobT = () => {
    // dispatch job title update.
    dispatch(uppdateJobTitle($('[name="cvtype"]').val()));
    {setTimeout(() => {
      toast.success("Job title updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }, 50)}
  }

  const generatePS = () => {
    if (window.location.pathname === "/user/profile/update/about") {
      // update about
      dispatch(uppdateAbout($('[name="goal"]').val()));
      {setTimeout(() => {
        toast.success("About updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
    }, 50)}
    } else {
      console.log("Technical skill", skills.skills);
      setPsStat(true);
      dispatch(clearPS());
      const cred = {
        Experience: activity.activities,
        Technical_skills: skills.skills,
        CvType: localStorage.getItem("jobTitle"),
      };
      dispatch(dispatchJobtitle($('[name="cvtype"]').val()));
      console.log("executing professional summary generating process");
      dispatch(generate_professional_summary(cred));
    }
  };

  let text = `${language["modal_AI"]}`
  let text1 = "Resume loading may take a minute.";

  const handleSaveAndPreview = () => {
    if (window.location.pathname === "/user/profile/update/about") {
      navigate(`/user/profile/:${userInfo.user.profile_id}`);
    } else {
      setHideModal(true);
      setLoading(true);
      let edu;
      if (education.education !== null && education.education !== undefined) {
        edu = education.education;
      } else {
        edu = [];
      }
      console.log("edu", edu);

    const credentials = {
			Fullname: personal_info.message.Firstname + " " + personal_info.message.LastName,
			MoreCert: cert.cert,
			Email: personal_info.message.Email,
			Phone_number: personal_info.message.Phone_number,
			Address: personal_info.message.Address,
			Professional_summary: summary.summary !== null ? summary.summary : data.get('goal'),
			Linkedin: personal_info.message.Linkedin,
			Website: personal_info.message.Website,
			Education: edu,
			Experience: activity.activities,
			Technical_skills: skills.skills, //data.get('technical_skills'),
			Personal_skills: p_skills.p_skills, //data.get('personal_skills'),
      Volunteer: voluteer.voluntary,
			Reference: reference.ref || [],
			Language: lang.lang, //data.get('language'),
			Interest: $('[name="interest"]').val(),
			CvType: title.jobtitle,
			Lang: ["English"],
			Award: award.award,
      year_of_experience: $('[name="YOF"]').val()
		};
    let sum;
    if (summary.summary !== null) {
      sum = summary.summary
    } else {
      sum = data.get('goal');
    }
    if (stat === "false" || stat === false) {
      dispatch(saveJobAndSum(title.jobtitle, sum, secret.secret));
    }
      console.log("credentials", credentials);
      dispatch(Cv_id(params));
      dispatch(generate_my_cv(credentials));
  };
}

  return (
    <div className="grid grid-cols-auto md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash">
      <TopBar topBarShowMenu={true} />
      <SideBar />
      <div className="px-3 lg:pl-6 my-8 w-full">
        {loading_stat.message !== null ? (
          <div>
            {hideModal &&
              createPortal(
                <PaymentMethodModal hideModal={showModal} />,
                document.querySelector("#modal")
              )}
          </div>
        ) : null}
        <div className="w-full max-w-[793px] h-[54px] bg-white bg-opacity-50 rounded-[40px] shadow border border-indigo-400 border-opacity-30 flex flex-col justify-center">
          <p className="text-stone-950 text-base md:text-[28px] font-semibold ml-12 max-[300px]:ml-6">
            {language["resume_caph1"]}
          </p>
        </div>
        <p className="w-full max-w-[741px] mt-2 px-3 lg:pl-6">
          <span className="text-black text-opacity-50 text-[14px] md:text-base font-">
            {language["Hey_there"]}
          </span>
        </p>
        <div className="max-w-[800px] w-full mt-8 p-8 bg-white bg-opacity-80 rounded-2xl shadow border border-indigo-400 border-opacity-30 flex-col justify-start items-start gap-16 inline-flex">
          <div className="tabarea justify-start items-center gap-6 inline-flex w-full flex-shrink-0 w-full max-w-[calc(100vw-88px)] overflow-hidden">
            <Tab
              num="1"
              current={false}
              completed={true}
              className="max-[650px]:hidden"
            />
            <Tab
              num="2"
              current={false}
              completed={true}
              className="max-[600px]:hidden"
            />
            <Tab
              num="3"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="4"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="5"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="6"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="7"
              current={false}
              completed={true}
              className="max-[360px]:hidden"
            />
            <Tab num="8" current={false} completed={true} />
            <Tab
              // label="Job Type"
              label={`${language["job_type"]}`}
              current={true}
              completed={false}
            />
          </div>
          <div className="flex-col justify-start items-start gap-12 flex w-full">
            <div className="flex-col justify-start items-start gap-4 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="jobType"
                >
                  {language["typejob_form9"]}
                </label>
              </div>
              <p className="text-orange-500 text-xs font-medium">
                {language["let_employer_know"]}
              </p>
              <input
                type="text"
                className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                placeholder={`${language["your_job_title_p"]}`}
                id="jobType"
                name="cvtype"
                onChange={(event) =>
                  localStorage.setItem("jobTitle", event.target.value)
                }
              />
              {path === true ? (
                <button
                  className="px-5 py-2.5 bg-orange-500 rounded-3xl border justify-start items-start gap-2.5 inline-flex"
                  onClick={updateJobT}
                >
                  <span className="text-center text-white text-base font-medium">
                    {language["update_job"]}
                  </span>
                </button>
              ) : null}
            </div>
            <div className="flex-col justify-start items-start gap-4 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="firstName"
                >
                  {language["years_experience"]}
                </label>
              </div>
              <input
                type="number"
                className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                placeholder={`${language["years_experience_place"]}`}
                id="school"
                name="YOF"
              />
              {path === true ? (
                <button
                  className="px-5 py-2.5 bg-orange-500 rounded-3xl border justify-start items-start gap-2.5 inline-flex"
                  onClick={updateYOF}
                >
                  <span className="text-center text-white text-base font-medium">
                    {language["update_years"]}
                  </span>
                </button>
              ) : null}
            </div>
            {/* <div className="flex-col justify-start items-start gap-4 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="firstName"
                >
                  {language["other_pro_interst"]}
                </label>
              </div>
              <input
                type="text"
                className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                placeholder={`${language["pro_exp_place"]}`}
                id="school"
                name="interest"
              />
              {path === true ? (
                <button
                  className="px-5 py-2.5 bg-orange-500 rounded-3xl border justify-start items-start gap-2.5 inline-flex"
                  onClick={updateInterest}
                >
                  <span className="text-center text-white text-base font-medium">
                    {language["update_pi"]}
                  </span>
                </button>
              ) : null}
            </div> */}
            <div className="flex-col justify-start items-start gap-4 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="professionalSummary"
                >
                  {language["pro_summary"]}
                </label>
              </div>
              <p className="text-orange-500 text-xs font-medium w-full">
                {language["describe_pro_sum"]}
              </p>
              <TextArea
                placeholder="0/500"
                id="professionalSummary"
                name="goal"
              />
              <button
                className="px-5 py-2.5 bg-orange-500 rounded-3xl border justify-start items-start gap-2.5 inline-flex"
                onClick={generatePS}
              >
                <span className="text-center text-white text-base font-medium">
                  {summaryBtnText}
                </span>
              </button>
            </div>
            {/* <div className="flex flex-col gap-4">
              <div className="flex gap-3 items-center">
                <div className="w-2 h-2 rounded-full bg-black px-1"></div>
                <label
                  className="text-black text-base font-medium"
                  for="firstName"
                >
                  {language["do_you_want"]}
                </label>
              </div>
              <div className="flex gap-3">
                <Radio name="hasAward" label="No" id="" />
                <Radio name="hasAward" label="Yes" id="" />
              </div>
            </div> */}
          </div>
          <div className="self-stretch flex-col sm:flex-row justify-between items-start gap-4 inline-flex">
          <button className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]" onClick= {props.handleStepChangeBack}>
            <span className="text-center text-orange-500 text-base font-semibold">
                {language["previous_btn"]}
            </span>
          </button>
          <button
            className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
            onClick={handleSaveAndPreview}
          >
            <span className="text-center text-white text-base font-semibold">
                {language["save_n_preview"]}
            </span>
          </button>
        </div>
        <ToastContainer />
        </div>
      </div>
      {loading === false ? null : (
        <div>
          {loading_stat.message === null && loading_stat.errMess === null ? (
            <LoaderModal text={text} />
          ) : null}
        </div>
      )}
      {loading === true ? (
        <div>
          {loading_stat.message === null && loading_stat.errMess === null ? (
            <LoaderModal text={text1} />
          ) : null}
        </div>
      ) : null}
      {PsStat === true ? (
        summary.summary !== null ? null : (
          <div>
            <LoaderModal text={text} />
          </div>
        )
      ) : null}
    </div>
  );
}